import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { validationRules } from "../utils/validationRules";
import supportService from "../services/supportService";

interface FormValues {
  firstName: string;
  email: string;
  description: string;
}

const initialData: FormValues = {
  firstName: "",
  email: "",
  description: "",
};

interface SupportFormProps {
  captchaConfigError: boolean;
  setIsLoading: (loading: boolean) => void;
}
const SupportForm: React.FC<SupportFormProps> = ({
  captchaConfigError,
  setIsLoading,
}) => {
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors: errorsState },
  } = useForm<FormValues>({
    defaultValues: initialData,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (data: FormValues) => {
    setIsLoading(true);
    try {
      const token = await executeRecaptcha!("survey_index");
      await supportService.postSupport(
        {
          name: data.firstName,
          email: data.email,
          description: data.description,
          captcha: token,
        },
        { captcha_action: "survey_index" }
      );
      setSuccess(true);
    } catch (error) {
      console.error("Error submitting request:", error);
      toast.error("Failed to submit request!");
    }
    setIsLoading(false);
  };
  return (
    <form
      name="feedback_data"
      onSubmit={handleSubmit(onSubmit)}
      className="form"
      id="csFeedbackForm"
    >
      <fieldset>
        {success ? (
          <div className="feedback-success">
            <h2>Your request has been submitted successfully.</h2>
            <h2>Thank You.</h2>
          </div>
        ) : (
          <>
            <h2>How can we help you?</h2>
            <div className="form-line form-group">
              <label htmlFor="feedback_data_username" className="required">
                Your Name
              </label>
              <input
                type="text"
                {...register("firstName", {
                  validate: validationRules.isNotEmpty,
                })}
              />

              {errorsState.firstName && (
                <span className="error_label">
                  {errorsState.firstName.message}
                </span>
              )}
            </div>
            <div className="form-line form-group">
              <label htmlFor="feedback_data_email" className="required">
                Email
              </label>
              <input
                type="email"
                {...register("email", {
                  validate: (value) => {
                    const firstValidation = validationRules.isNotEmpty(value);
                    if (firstValidation === true) {
                      return validationRules.isEmail(value);
                    }

                    return firstValidation;
                  },
                })}
              />
              {errorsState.email && (
                <span className="error_label">{errorsState.email.message}</span>
              )}
            </div>
            <div className="form-line form-group">
              <label htmlFor="feedback_data_description">Description</label>
              <textarea
                id="feedback_data_description"
                {...register("description", {
                  validate: validationRules.isNotEmpty,
                })}
              ></textarea>
              {errorsState.description && (
                <span className="error_label">
                  {errorsState.description.message}
                </span>
              )}
            </div>
            <div className="submit-line">
              <button type="submit" disabled={captchaConfigError}>
                Submit request
              </button>
              {captchaConfigError && (
                <div className="error_label">
                  Sorry, captcha was not recognized!
                </div>
              )}
            </div>
          </>
        )}
      </fieldset>
    </form>
  );
};

export default SupportForm;
